import React, { useState, useEffect } from "react";
import { FaHeart, FaShoppingBag, FaUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import "./Preheader.css";
import logo from "../../assets/Kalimages/mainlogo.png";
import axios from "axios";

const Preheader = () => {
  const [email, setEmail] = useState(null);
  const [userName, setUserName] = useState(null);
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [products, setProducts] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    // Fetch user email from session storage if available
    const userData = JSON.parse(sessionStorage.getItem("user"));
    if (userData && userData.email) {
      setEmail(userData.email);
      setUserName(userData.fullname || userData.email.split("@")[0]);
    }
  }, []);

  useEffect(() => {
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (!event.target.closest(".preheader-profile-dropdown")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const cartData = sessionStorage.getItem("userCart");
  const wishlistData = sessionStorage.getItem("userWishlist");
  useEffect(() => {
    const updateCartAndWishlistCounts = () => {
      if (cartData) {
        try {
          const cart = JSON.parse(cartData);

          const totalItems = Object.values(cart).reduce(
            (total, item) => total + item.quantity,
            0
          );
          setCartCount(totalItems);
        } catch (error) {
          console.error("Error parsing cart data:", error);
          setCartCount(0);
        }
      } else {
        setCartCount(0);
      }

      if (wishlistData) {
        try {
          const wishlist = JSON.parse(wishlistData);
          setWishlistCount(wishlist.length);
        } catch (error) {
          console.error("Error parsing wishlist data:", error);
          setWishlistCount(0);
        }
      } else {
        setWishlistCount(0);
      }
    };

    updateCartAndWishlistCounts();

    const handleStorageChange = (e) => {
      if (e.key === "userCart" || e.key === "userWishlist") {
        updateCartAndWishlistCounts();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [wishlistData, cartData]);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList"
      );
      if (response.data) {
        setProducts(response.data);
      } else {
        console.log("No data received");
      }
    } catch (error) {
      console.log("Error fetching products: ", error);
    }
  };

  // Handle input change and filter suggestions
  const handleInputChange = (e) => {
    const input = e.target.value.toLowerCase().trim();
    setQuery(input);

    if (input.length > 0 && products.length > 0) {
      const matches = products
        .filter((product) => product.productName.toLowerCase().includes(input))
        .map((product) => ({
          name: product.productName,
          id: product.id,
          product: product,
        }));

      setFilteredSuggestions(matches);
      setShowSuggestions(true);
    } else {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setShowSuggestions(false);

    if (filteredSuggestions.length > 0) {
      const firstMatch = filteredSuggestions[0];
      navigate(`/product/${firstMatch.id}`, {
        state: { product: firstMatch.product },
      });
    } else if (query.trim()) {
      setShowAlert(true);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setQuery(suggestion.name);
    setShowSuggestions(false);
    navigate(`/product/${suggestion.id}`, {
      state: { product: suggestion.product },
    });
  };

  const handleLogout = () => {
    sessionStorage.clear();
    setEmail(null);
    setUserName(null);
    setShowDropdown(false);
    navigate("/");
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <>
      <div className="preheader">
        <div className="container">
          {/* Desktop View */}
          <div className="d-none d-md-flex align-items-center justify-content-between">
            {/* Logo */}
            <div className="preheader-logo">
              <Link to="/" className="text-decoration-none">
                <div className="preheader-mainlogotitle">
                  Kalanjiyam
                  <br />
                  <span className="preheader-subtitle">Boutique.</span>
                </div>
              </Link>
            </div>

            {/* Search Bar */}
            <div className="preheader-search position-relative">
              <form onSubmit={handleSearch}>
                <input
                  type="text"
                  className="form-control preheader-search-input"
                  placeholder="I'm Shopping For..."
                  value={query}
                  onChange={handleInputChange}
                  onFocus={() => query.length > 0 && setShowSuggestions(true)}
                />
              </form>
              {showSuggestions && filteredSuggestions.length > 0 && (
                <div className="preheader-suggestions">
                  {filteredSuggestions.slice(0, 5).map((suggestion, i) => (
                    <div
                      key={i}
                      className="preheader-suggestion-item"
                      onClick={() => handleSuggestionClick(suggestion)}
                    >
                      {suggestion.name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Action Buttons */}
            <div className="d-flex align-items-center gap-3">
              {/* Wishlist Button */}
              <Link
                to="/MyProfile/Wishlist"
                className="preheader-action-btn position-relative"
              >
                <FaHeart className="me-2" />
                Wishlist
                {wishlistCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {wishlistCount}
                  </span>
                )}
              </Link>

              <Link
                to="/MyProfile/Addtocart"
                className="preheader-action-btn position-relative"
              >
                <FaShoppingBag className="me-2" />
                Cart
                {cartCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {cartCount}
                  </span>
                )}
              </Link>

              {/* Profile Button */}
              <div className="preheader-profile-dropdown position-relative">
                {email ? (
                  <>
                    <button
                      className="preheader-profile-btn"
                      onClick={toggleDropdown}
                    >
                      <div className="preheader-avatar">
                        {userName?.charAt(0).toUpperCase() || "U"}
                      </div>
                      <span
                        className="ms-2"
                        style={{
                          width: "max-content",
                          display: "flex",
                          flexWrap: "nowrap",
                        }}
                      >
                        {userName}
                      </span>
                    </button>
                    {showDropdown && (
                      <div className="preheader-dropdown-menu">
                        <Link
                          to="/myProfile"
                          className="preheader-dropdown-item"
                        >
                          My Profile
                        </Link>
                        <Link
                          to="/TrackYourOrder/myOrders"
                          className="preheader-dropdown-item"
                        >
                          My Orders
                        </Link>
                        <button
                          className="preheader-dropdown-item preheader-dropdown-logout"
                          onClick={handleLogout}
                        >
                          Log Out
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  <Link to="/login" className="preheader-login-btn">
                    <FaUser className="me-2" />
                    Log In
                  </Link>
                )}
              </div>
            </div>
          </div>

          {/* Mobile View */}
          <div className="d-flex d-md-none align-items-center justify-content-between flex-row no-wrap">
            {/* Logo */}
            <div className="preheader-logo">
              <Link to="/" className="text-decoration-none">
                <div className="preheader-mainlogotitle mobile">
                  Kalanjiyam
                  <span className="preheader-subtitle mobile">Boutique.</span>
                </div>
              </Link>
            </div>

            {/* Search Bar */}
            <div className="preheader-search mobile position-relative">
              <form onSubmit={handleSearch}>
                <input
                  type="text"
                  className="form-control preheader-search-input"
                  placeholder="Search..."
                  value={query}
                  onChange={handleInputChange}
                  onFocus={() => query.length > 0 && setShowSuggestions(true)}
                />
              </form>
              {showSuggestions && filteredSuggestions.length > 0 && (
                <div className="preheader-suggestions">
                  {filteredSuggestions.slice(0, 5).map((suggestion, i) => (
                    <div
                      key={i}
                      className="preheader-suggestion-item"
                      onClick={() => handleSuggestionClick(suggestion)}
                    >
                      {suggestion.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Alert Modal */}
        {showAlert && (
          <div
            className="modal show preheader-alert-modal"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title text-danger">Dear User</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowAlert(false)}
                    type="button"
                  ></button>
                </div>
                <div className="modal-body">
                  <p className="text-danger">
                    No matching products found. Please try again.
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-backdrop show"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default Preheader;
